export const mbProduct = {
  mbproduct: {
    selectA: 'Select a',
    chooseProduct: 'Choose your product',
    review: 'Review',
    reviews: 'Reviews',
    galleryMainImage: 'Gallery main image',
    relatedProductsFor: 'Related products for',
    doYouNeedAnythingElse: 'Do you need anything else?',
    recommendedProducts: 'Recommended products',
    recombinant: 'RECOMBINANT',
    validation: 'EXTENDED VALIDATION',
    image: 'Image: ',
    description: 'Description',
    synonyms: 'Synonyms'
  },

  mbProductTabs: {
    referencesFor: 'References for',
    publications: 'Publications',
    reviewsFor: 'Reviews for ',
    writeAReview: 'Write a review',
    readMore: 'Read more',
    readLess: 'Read less',
    poweredBy: 'powered by',
    allPublications: 'All publications',
    allPublicationsLowerCase: 'all publications',
    applicationsFor: 'applications for',
    viewDetails: 'view details',
    description: 'Description',
    specificationsFor: 'Specifications for',
    extendedValidationFor: 'Extended validation for',
    specsOverview: 'Overview',
    detailedProductInfo: 'Detailed product information',
    extendedValidationSpecificity: 'Specificity',
    extendedValidationSensitivity: 'Sensitivity',
    extendedValidationEpitopeCompetition: 'Epitope competition',
    technicalSpecifications: 'Technical specifications',
    technicalData: 'Technical data',
    productDataImagesFor: 'Product data and images for',
    resourcesFor: 'Resources for',
    documentsAndProtocols: 'Documents and Protocols',
    certificates: 'Certificates'
  },

  productListComponent: {
    matchingProducts: 'Matching products:',
    filterYourResults: 'Filter your results:'
  }
}
